import { useTheme } from "styled-components";

import { useMedia } from "react-use";

import { SmoothScrollScroller } from "./SmoothScrollScroller";
import { Box } from "./Box";

export const SmoothScroll: React.FC = ({ children }) => {
  const theme = useTheme();
  const isWide = useMedia(`(min-width: ${theme.breakpoints[1]})`);

  return (
    <>
      {isWide ? (
        <SmoothScrollScroller>{children}</SmoothScrollScroller>
      ) : (
        <Box overflow="hidden"> {children} </Box>
      )}
    </>
  );
};
